import React from 'react';
import s from './Header.scss';
import { Logo } from './Logo';
import { useViewport } from '../../hooks/useViewport';
import { Box } from '@wix/design-system';

export const Header = () => {
  const { isMobile } = useViewport();

  return (
    <div className={s.Header}>
      <header className={s.Header__component}>
        <Box direction="horizontal" verticalAlign="middle" gap="SP1" className={s.Header__left}>
          <Logo height={isMobile ? 16 : 24} />
        </Box>
      </header>
    </div>
  );
};
